import http, { createApi } from '@core/fetch'
import {} from '@util'

export const Api = {
  getStoreTypeApi: createApi(
    '/p/wedding/index.php/Home/APIManagers/properties'
  ),
  //三级地址
  getPCCApi: createApi('/p/wedding/shop/APIShopAddress/AllAddress'),
  //创建成员
  createGroupMember: createApi.post(
    '/hps/mainAdmin/localServerMerchant/fourRole/createGroupMember'
  ),
  // 2021/0520改版 创建/保存团队成员
  emceeMemberSumbit: body =>
    http.post('/hms/merchant/adminApi/emceeMember/submit', {
      body,
      onError: null
    }),
  // 获取团队成员信息
  getEmceeMemberDetail: createApi('/hms/merchant/adminApi/emceeMember/detail'),
  // 违禁词校验
  checkBanedWord: content =>
    http.get('/hms/basicData/appApi/sensitiveWord/check', {
      body: { content, productName: '婚礼纪', scene: '违规词' }
    })
}
